<!-- goals mid page -->
<script setup lang="ts">
import {
  IonContent,
  IonFab,
  IonFabButton,
  IonLoading,
  IonSpinner,
  IonPage,
  IonIcon,
  useIonRouter,
} from '@ionic/vue';
import BSlideHeader from '@/components/BSlideHeader.vue';
import Flag from '@/components/illustrations/Flag.vue';
import { computed, provide, ref, onMounted, onUnmounted } from 'vue';
import { homeSharp } from 'ionicons/icons';
import { useStore } from '@/stores/main';
import monsterUrl from '/assets/monster/glad.png';
import SpeechBubble from '@/components/SpeechBubble.vue';

const router = useIonRouter();

const goHome = () => router.navigate('/evaluate', 'root', 'replace');

function goBack() {
  router.back();
}

async function next() {
  router.push('/goals/improve');
}

const colorScheme = 'blue';

provide('pageData', {
  number: 3,
  title: 'Mina mål',
  icon: Flag,
});
provide('colorScheme', colorScheme);

// export function useScreenSize() {
const screenSize = ref('');
</script>

<template>
  <ion-page>
    <ion-content :fullscreen="true" class="goals-mid-content">
      <ion-fab slot="fixed" class="md:mr-[5%] lg:mt-[4%] md:mt-[6%] mt-[1%]">
        <ion-fab-button @click="goHome">
          <ion-icon :icon="homeSharp" />
        </ion-fab-button>
      </ion-fab>

      <b-slide-header />

      <!-- Monster + Bubble centered, monster feet touch footer -->
      <div class="monster-bubble-wrapper">
        <div class="flex justify-center flex-col items-center relative mx-auto">
          <div class="relative flex justify-center items-center">
            <speech-bubble
              :color="'blue'"
              class="w-[200px] md:w-[220px]"
            />
            <div
              class="absolute lg:text-[15px] text-[min(5vw,1.15rem)] text-center w-[70%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
            >
              Va bra! Stanna upp lite nu och fundera på hur det påverkar ditt
              liv.
            </div>
          </div>
          <img class="monster shrink-0 -mt-4" :src="monsterUrl" alt="Monster" />
        </div>
      </div>
    </ion-content>

    <!-- Fixed footer navigation -->
    <div class="goals-footer">
      <div class="grid grid-cols-2 gap-4 max-w-lg mx-auto">
        <b-button @click="goBack" look="secondary">Tillbaka</b-button>
        <b-button @click="next">Nästa</b-button>
      </div>
    </div>
  </ion-page>
</template>

<style scoped>
ion-fab {
  right: 0.5rem;
  top: 90px;
}

ion-content {
  --keyboard-offset: 0 !important;
}

.goals-mid-content {
  --background: #f3fffe;
  --padding-bottom: 80px;
}

.monster-bubble-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  min-height: calc(100vh - 180px);
  padding-bottom: 0;
}

.goals-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem 2rem;
  background-color: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  z-index: 100;
}

@media (min-width: 1024px) {
  .goals-footer {
    background-color: #a1cdc5;
  }
}

.monster {
  transition: transform 0.3s ease-in-out;
}
</style>
